<template>
  <div class="row">
    <div class="col-12 col-md-4 mb-4">
      <div class="row">
        <div class="col-12">
          <base-input label="Nome" name="nome" rules="required" v-model="region.name" />
        </div>

        <div class="col-12">
          <div>
            <label class="form-control-label mb-4">Área de Atuação</label>
            <base-slider v-model="radius" label="Raio" :options="tooltipOptions"></base-slider>
          </div>
        </div>

        <div class="col-12">
          <label class="form-control-label">Filial</label>
          <multiselect
            v-model="branch"
            :options="branches"
            placeholder="Selecionar Filial"
            label="name"
            :selected-label="'Selecionado'"
            track-by="id"
          />
        </div>

        <div class="col-12">
          <label class="form-control-label mt-4">Latitude</label>
          <base-input name="latitude" v-model="lat" readonly />
        </div>

        <div class="col-12">
          <label class="form-control-label">Longitude</label>
          <base-input name="longitude" v-model="long" readonly />
        </div>

      </div>
    </div>
    <div class="col-12 col-md-8" style="position: relative">
      <region-map 
        :marker="localRegion.region_position"
        marker-draggable 
        style="min-height: 400px; max-height: 40vh;"
        v-on:update:marker="setMarker" 
        :single="true" :radius="Number(radius)" />
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, defineEmits, onMounted, watch, reactive } from 'vue';
import axios from "@/backend/axios/index.js";
import BaseSlider from "@/components/BaseSlider";
import RegionMap from '@/views/Sectors/regionMap';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const props = defineProps({
  region: Object,
});
const lat = ref("");
const long = ref("");
const emit = defineEmits(['update:region']);

const localRegion = reactive({
  ...props.region
});

watch(
  () => props.region,
  (newRegion) => {
    Object.assign(localRegion, newRegion);
  }
);

watch(
  () => localRegion.region_position,
  (newRegionPosition, oldRegionPosition) => {
    if (newRegionPosition) {
      lat.value = newRegionPosition.lat || "";
      long.value = newRegionPosition.long || "";

      if (localRegion.branch_id !== props.region.branch_id) {
        // console.log(" Mantendo `branch_id` atualizado após mudança de posição");
      } else {
        localRegion.branch_id = props.region.branch_id; // Garante que não volte ao valor original
      }

      emit("update:region", { ...localRegion });
    }
  },
  { deep: true, immediate: true }
);

watch(
  () => localRegion,
  (newLocalRegion) => {
    emit('update:region', { ...newLocalRegion, branch_id: newLocalRegion.branch_id });
  },   { deep: true }
    
    )

const radius = computed({
  get: () => parseFloat(localRegion.region_position.radius) || 4500,
  set: (value) => {
    if (localRegion.region_position) {
      localRegion.region_position.radius = value;
      localRegion = { ...localRegion };
    }
  },
});

const setMarker = (marker) => {
  if (!localRegion.region_position) {
    localRegion.region_position = { lat: 0, long: 0, coordinates: [0, 0] };
  }
  localRegion.branch_id || props.region.branch_id;
  localRegion.region_position.lat = marker.coordinates[0];
  localRegion.region_position.long = marker.coordinates[1];
  localRegion.region_position.coordinates = [...marker.coordinates];

  lat.value = marker.coordinates[0];
  long.value = marker.coordinates[1];

  emit("update:region", { ...localRegion });

};

const tooltipOptions = {
  tooltips: [{ to: (value) => `${value.toLocaleString('pt-BR')} m²` }],
  range: { min: 100, max: 100000 },
  step: 1,
};

const branches = ref([]);
const branch = computed({
  get: () => branches.value.find(b => b.id === localRegion.branch_id),
  set: (value) => {
    localRegion.branch_id = value.id;
    emit("update:region", { ...localRegion });
  },
});

const getBranches = async () => {
  try {
    const response = await axios.get('/api/v1/branches');
    branches.value = response.data;
  } catch (error) {
    console.error('[RegionForm.vue] getBranches', error);
  }
};

onMounted(() => {
  getBranches();
});
</script>
